'use client';

import type { ButtonProps } from '@chakra-ui/react';
import { Collapsible, Button as ChakraButton } from '@chakra-ui/react';
import { IoChevronDownSharp } from 'react-icons/io5';

import { FormSection } from './FormSection';

const Trigger = ({ children }: { children: React.ReactNode }) => {
	return (
		<Collapsible.Trigger asChild>
			<FormSection.Header>
				<FormSection.Title>
					{children}
					<Collapsible.Indicator
						_open={{ transform: 'rotate(180deg)' }}
						transition="transform 0.2s"
					>
						<IoChevronDownSharp />
					</Collapsible.Indicator>
				</FormSection.Title>
			</FormSection.Header>
		</Collapsible.Trigger>
	);
};

const Root = ({ children }: { children: React.ReactNode }) => {
	return (
		<FormSection.Root>
			<Collapsible.Root>
				{children}
			</Collapsible.Root>
		</FormSection.Root>
	);
};

const Button = (props: ButtonProps) => {
	return (
		<ChakraButton mx="auto" size="md" w="200px" {...props} />
	);
};

export const CollapsibleFormSection = {
	Body:            FormSection.Body,
	Button,
	Collapsible:     Collapsible.Content,
	CollapsibleRoot: Collapsible.Root,
	Column:          FormSection.Column,
	Description:     FormSection.Description,
	Field:           FormSection.Field,
	Footer:          FormSection.Footer,
	FormRoot:        FormSection.Root,
	Root:            Root,
	Row:             FormSection.Row,
	Trigger:         Trigger,
};
